<template>
  <base-creation-page v-if="insertData" :insertData="insertData" />
</template>

<script>
export default {
  setup() {
    //structure of page
    const insertData = {
      title: "Inserimento nuova Rfid",
      redirect_path: "/rfid",
      create_endpoint: "createRfid",
      creation_title: "Creazione rfid",
      dispatchName: "getCompleteRfidList",
      data: [
        {
          title: "Tag",
          name: "id_tag",
          required: true,
        },
        {
          title: "Codice",
          name: "codice",
          required: true,
          placeholder: "es.00001",
        },
        {
          title: "Bonus",
          name: "euro_bonus",
          placeholder: "7.80€",
        },
      ],
    };
    //return fields
    return {
      insertData,
    };
  },
};
</script>

<style>
</style>